import { PopoverList } from "@xola/ui-kit";
import React, { useState } from "react";
import { FilterMenuButton } from "../Dashboard/Filters/FilterMenuButton";

export interface VariableItem {
    name: string;
    title: string;
    type: string;
}

export interface VariablesButtonProps {
    onInsertVariable: (t: React.MouseEvent<HTMLElement>, name: string) => void;
    items: VariableItem[];
    showType?: boolean;
}

export const VariablesButton = ({ onInsertVariable, items, showType = true }: VariablesButtonProps) => {
    const [visible, setVisible] = useState(false);

    const hide = () => {
        setVisible(false);
    };

    const toggle = () => {
        setVisible(!visible);
    };

    const handleItemClick = (t: React.MouseEvent<HTMLElement>, name: string) => {
        hide();
        onInsertVariable(t, name);
    };

    return (
        <PopoverList visible={visible} className="max-h-60 !w-72 overflow-y-auto" onClickOutside={hide}>
            <FilterMenuButton isDropdown text="Variables" className="!min-w-[120px]" onClick={toggle} />

            {items.map(({ name, title, type }) => {
                return (
                    <PopoverList.Item key={name} name={name} onClickItem={handleItemClick}>
                        <div className="flex w-full" data-testid="variables-button">
                            <div className="flex-grow">{title}</div>
                            {showType ? <div className="text-sm font-normal text-gray-dark">{type}</div> : null}
                        </div>
                    </PopoverList.Item>
                );
            })}
        </PopoverList>
    );
};
